import { combineReducers } from "redux";
import cartReducer from "../cart/services/cart/reducer";
import filtersReducer from "../cart/services/filters/reducer";
import orderReducer from "../cart/services/order/reducer";
import shelfReducer from "../cart/services/shelf/reducer";
import sortReducer from "../cart/services/sort/reducer";
import totalReducer from "../cart/services/total/reducer";
import authReducer from "./authReducer";
import checkboxReducer from "./checkboxReducer";
import companyDataReducer from "./companyDataReducer";
import companySaveReducer from "./companySaveReducer";
import docApprovingReducer from "./docApprovingReducer";
import docCommettingReducer from "./docCommettingReducer";
import docSignReducer from "./docSignReducer";
import docSubmittingReducer from "./docSubmittingReducer";
import draftDocsReducer from "./draftDocsReducer";
import employeeBioDataMasterReducer from "./employeeBioDataMasterReducer";
import employeeBioDataReducer from "./employeeBioDataReducer";
import employeeTravelLinkReducer from "./employeeTravelLinkReducer";
import employeeTravelReducer from "./employeeTravelReducer";
import errorReducer from "./errorReducer";
import fileUploadReducer from "./fileUploadReducer";
import getDocsReducer from "./getDocsReducer";
import getDocsReqReducer from "./getDocsReqReducer";
import getNotificationsReducer from "./getNotificationsReducer";
import getOfficeIdDocReducer from "./getOfficeIdDocReducer";
import getOneDocReducer from "./getOneDocReducer";
import imageUploadReducer from "./imageUploadReducer";
import inputsReducer from "./inputsReducer";
import loadRoutesReduce from "./loadRoutesReduce";
import officeDataReducer from "./officeDataReducer";
import officeSaveReducer from "./officeSaveReducer";
import shopAlbumReducer from "./shopAlbumReducer";
import shopDataReducer from "./shopDataReducer";
import shopSaveImagesReducer from "./shopSaveImagesReducer";
import shopSaveInfoReducer from "./shopSaveInfoReducer";
import userStatusReducer from "./userStatusReducer";

export default combineReducers({
	error: errorReducer,
	auth: authReducer,
	checkbox: checkboxReducer,
	fileupload: fileUploadReducer,
	inputsave: inputsReducer,
	loadRoutes: loadRoutesReduce,
	docs: getDocsReducer,
	onedocs: getOneDocReducer,
	docSubmit: docSubmittingReducer,
	officedocs: getOfficeIdDocReducer,
	draftDocs: draftDocsReducer,
	docComment: docCommettingReducer,
	docApprove: docApprovingReducer,
	docsreq: getDocsReqReducer,
	imageUpload: imageUploadReducer,
	userStatus: userStatusReducer,
	docSign: docSignReducer,
	getNotications: getNotificationsReducer,
	employeeBioData: employeeBioDataReducer,
	employeeBioDataMaster: employeeBioDataMasterReducer,
	employeeTravel: employeeTravelReducer,
	employeeTravelLink: employeeTravelLinkReducer,
	shopSaveInfo: shopSaveInfoReducer,
	shopData: shopDataReducer,
	shopAlbum: shopAlbumReducer,
	shopSaveImages: shopSaveImagesReducer,
	companySave: companySaveReducer,
	companyData: companyDataReducer,
	officeSave: officeSaveReducer,
	officeData: officeDataReducer,
	shelf: shelfReducer,
	cart: cartReducer,
	total: totalReducer,
	filters: filtersReducer,
	sort: sortReducer,
	order: orderReducer,
});
